<header class="header">
  <img alt="Agridence" class="header__logo" src="assets/images/agd-icon.svg" />
  <span class="header__title">{{ title }}</span>
</header>
